import { render, staticRenderFns } from "./WhyChooseScad.vue?vue&type=template&id=cbb4648a&scoped=true&"
import script from "./WhyChooseScad.vue?vue&type=script&lang=js&"
export * from "./WhyChooseScad.vue?vue&type=script&lang=js&"
import style0 from "./WhyChooseScad.vue?vue&type=style&index=0&id=cbb4648a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb4648a",
  null
  
)

export default component.exports